export function blobToBase64(blob: Blob) {
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onloadend = () => resolve("" + reader.result)
        reader.onerror = reject
    })
}

export async function blobToJson(blob: Blob): Promise<unknown> {
    return JSON.parse(await blob.text())
}
